export type TokenProvider = () => Promise<string | null>;

/** Signed-in identity backing every synced store: the Clerk token getter AND
 *  the current user id. The id is needed (not just the token) to stamp/
 *  verify local-cache ownership on account switch — see cache-ownership.ts. */
export type AuthIdentity = { getToken: TokenProvider; userId: string };

let authIdentity: AuthIdentity | null = null;
const listeners = new Set<() => void>();

/** Registers (or clears, with `null`) the signed-in identity backing every
 *  synced store. Idempotent — call it as often as auth state changes.
 *  Listeners fire on every call so each store-instance module can drop its
 *  cached synced store and rebuild lazily against the new identity. */
export function setAuthTokenProvider(p: AuthIdentity | null): void {
	authIdentity = p;
	for (const cb of listeners) cb();
}

/** Read-only view of the registered identity — the diagram-room WS client
 *  needs the token getter for ticket minting and uses `null` as its
 *  "signed-out, don't connect" signal. */
export function getAuthIdentity(): AuthIdentity | null {
	return authIdentity;
}

/** Subscribe to identity changes. Returns an unsubscribe function. */
export function onAuthIdentityChange(cb: () => void): () => void {
	listeners.add(cb);
	return () => {
		listeners.delete(cb);
	};
}
